import { motion } from "framer-motion";

export const About = () => {
  return (
    <section
      id="nosotros"
      data-testid="about-section"
      className="relative bg-white py-24 sm:py-32 border-t border-[#BFBFBF]/40"
    >
      <div className="max-w-7xl mx-auto px-6 sm:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-20 items-start">
          <motion.div
            initial={{ opacity: 0, y: 24 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, amount: 0.3 }}
            transition={{ duration: 0.7 }}
            className="lg:col-span-5"
          >
            <div className="text-[11px] tracking-[0.3em] uppercase text-[#BF1828] font-medium">
              Sobre Nosotros
            </div>
            <h2
              data-testid="about-heading"
              className="mt-5 font-display font-medium text-4xl sm:text-5xl tracking-tight leading-[1.05] text-black"
            >
              Simple Solutions
              <br />
              <span className="text-[#BF1828]">Asesores.</span>
            </h2>
            <div className="mt-10 hidden lg:block">
              <img
                src="https://customer-assets.emergentagent.com/job_dynamic-trust/artifacts/049o0v2x_nosotros.webp"
                alt="Espacio creativo de trabajo"
                className="w-full h-[340px] object-cover"
              />
            </div>
          </motion.div>

          <motion.div
            initial={{ opacity: 0, y: 24 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, amount: 0.3 }}
            transition={{ duration: 0.7, delay: 0.15 }}
            className="lg:col-span-7"
          >
            <p
              data-testid="about-paragraph-1"
              className="font-display font-light text-2xl sm:text-3xl leading-[1.3] text-black tracking-tight text-pretty"
            >
              Somos la respuesta definitiva para las marcas que buscan impactar
              y crecer sin complicaciones.
            </p>
            <p
              data-testid="about-paragraph-2"
              className="mt-8 font-body text-base sm:text-lg leading-relaxed text-[#595959] max-w-2xl"
            >
              Como agencia integral, transformamos ideas complejas en campañas
              publicitarias memorables, estrategias de marketing de vanguardia
              y diseños de alto impacto que cautivan audiencias. Nos apasiona
              optimizar la presencia de nuestros clientes en el mercado masivo
              y digital, fusionando la creatividad publicitaria con un sólido
              catálogo de servicios de soporte corporativo que impulsa y
              aligera la operación diaria de cualquier empresa.
            </p>

            <div className="mt-12 border-l-2 border-[#BF1828] pl-6">
              <div
                className="text-[11px] tracking-[0.3em] uppercase text-[#BF1828] font-medium"
                data-testid="about-history-eyebrow"
              >
                Historia de Nuestra Empresa
              </div>
              <p
                data-testid="about-history-text"
                className="mt-4 font-body text-[15px] sm:text-base leading-relaxed text-[#595959]"
              >
                Nacimos en Zapoapan, Jalisco como un estudio enfocado en el
                diseño y la consultoría de marcas, identificando rápidamente
                que las empresas necesitaban un aliado que no solo creara
                ideas, sino que resolviera su ejecución integral. Desde nuestro
                nacimiento evolucionamos expandiendo nuestras capacidades hacia
                la producción impresa, la gestión de relaciones públicas y la
                logística de eventos, consolidando un ecosistema de soluciones
                comerciales único. Hoy, nos posicionamos como una agencia
                consolidada que ha simplificado el crecimiento de decenas de
                negocios, adaptando la publicidad tradicional a las exigencias
                digitales de la era moderna.
              </p>
            </div>
          </motion.div>
        </div>
      </div>
    </section>
  );
};
